var map = {
	"./answers.svg": 31995,
	"./background.svg": 60946,
	"./bt0.svg": 77499,
	"./bt1.svg": 35497,
	"./bt2.svg": 38010,
	"./bt3.svg": 59544,
	"./discs.svg": 33596,
	"./knob.svg": 50150,
	"./knob_bg.svg": 46189,
	"./knob_shadow.svg": 60732,
	"./symbol1.svg": 90524,
	"./symbol2.svg": 60710,
	"./symbol3.svg": 38218,
	"./symbol4.svg": 83642,
	"./symbol5.svg": 65688,
	"./tri0.svg": 45388,
	"./tri1.svg": 96652,
	"./tri2.svg": 21063,
	"./tri3.svg": 31182,
	"./tri4.svg": 62335,
	"./tri5.svg": 7298,
	"./tri6.svg": 51020
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50510;